import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';

import ProductList from '../product-list';
import HomeSlider from '../home-slider';
import Loader from '../shared/loader';
import Layout from '../layout';

import styles from '../styles/pages/homepage.scss';
import CategorySlider from '../category-slider';
import APP_ROUTES from '../../constants/app-routes';
import SignupPromotion from '../shared/signup-promotion';
import SecondaryMenuConnector from '../../containers/menus/secondary-menu-connector';
import Configs from '../../configs';

class HomePage extends Component {
    constructor(props) {
        super(props);

        document.title = this.props.intl.formatMessage({ id: 'title', defaultMessage: 'Online Store for Cuba' });
    }

    componentDidMount() {
        this.props.loadStores(this.props.locale.currentLocale, this.props.currentStore);
    }

    /* If home page icon is clicked. */
    componentDidUpdate(prevProps, prevState) {
        if (prevProps.location.pathname !== this.props.location.pathname || prevProps.locale.currentLocale !== this.props.locale.currentLocale) {
            this.props.loadStores(this.props.locale.currentLocale, this.props.currentStore);
        }

        if (this.props.locale !== prevProps.locale) {
            document.title = this.props.intl.formatMessage({ id: 'title', defaultMessage: 'Online Store for Cuba' });
        }
    }

    render() {
        const setCurrentStore = (store) => {
            this.props.setCurrentStore(this.props.locale.currentLocale, store);
        };
        return (
            <Layout>
                <div className={styles.homepage}>
                    <HomeSlider locale={this.props.locale} />
                    {Configs.HOME.STORES_IN_ZONES && (
                        <CategorySlider
                            taxons={this.props.taxons}
                            storesGrouped={this.props.storesGrouped}
                            currentZone={this.props.currentZone}
                            currentStore={this.props.currentStore}
                            setCurrentStore={setCurrentStore}
                        />
                    )}

                    <div className={`container body-container ${styles.bodyContainer}`}>
                        <div className="row">
                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                <div className="text-center">
                                    <div className={`${styles.productTitle}`}>
                                        <FormattedMessage id="products" defaultMessage="Products" />
                                        <div>
                                            <Loader displayLoader={this.props.displayLoader} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className={`col-lg-3 col-md-3 col-sm-4 col-xs-12 ${styles.colFilters}`}>
                                <SecondaryMenuConnector location={this.props.location} path={APP_ROUTES.searchPageRoute} />
                            </div>
                            <div className="col-lg-9 col-md-9 col-sm-8 col-xs-12">
                                <div className="row">
                                    {!this.props.displayLoader && (
                                        <ProductList
                                            products={this.props.products}
                                            loadMoreProducts={this.props.loadMoreProducts}
                                            pageCount={this.props.pageCount}
                                            locale={this.props.locale}
                                        />
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Layout>
        );
    }
}

export default injectIntl(HomePage);



/** WEBPACK FOOTER **
 ** ./src/components/pages/home-page.jsx
 **/